import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommendSection from './components/HotRecommendSection';
import CategorySection from './components/CategorySection';
import LatestUpdateSection from './components/LatestUpdateSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import NewsletterSection from './components/NewsletterSection';
import { popularComics, newComics } from '@/mocks/comics';
import { testimonials } from '@/mocks/testimonials';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '酷漫屋',
  alternateName: 'KUMANWU',
  url: 'http://lst56.com/',
  description: '酷漫屋为您提供下拉式免费漫画和韩漫在线观看服务，涵盖丰富的韩国漫画大全。高清画质，每日更新，永久免费。',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://lst56.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '酷漫屋',
  url: 'http://lst56.com/',
  description: '国内领先的免费漫画阅读平台，专注提供优质韩漫、国漫等各类漫画资源',
  sameAs: ['http://lst56.com/'],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="酷漫屋 - 下拉式免费漫画 | 韩漫在线观看 | 韩国漫画大全"
        description="酷漫屋为您提供下拉式免费漫画和韩漫在线观看服务，涵盖丰富的韩国漫画大全。无论您喜欢什么类型，都能轻松浏览并沉浸在高清画面中。每日更新，永久免费。"
        keywords="酷漫屋,下拉式免费漫画,韩漫在线观看,韩国漫画大全,免费漫画,韩漫"
        canonicalUrl="http://lst56.com/"
        jsonLd={{ ...homeJsonLd }}
      />

      {/* Separate Organization JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <HotRecommendSection hotComics={popularComics} />
          <CategorySection />
          <LatestUpdateSection latestComics={newComics} />
          <TestimonialSection testimonials={testimonials} />
          <CTASection />
          <NewsletterSection />
        </main>
        <Footer />
      </div>
    </>
  );
}